type AccessCodeData = {
	bundleId: string;
	bundleNumericId: number;
	bundleName: string;
	planLength: string;
	expiryDate: string;
	examName: string;
	examId: string;
	bundleType: "STUDY_PACK" | "PRACTICE_TEST";
	icon: string;
	features: string[];
	isCustomAccess: boolean;
	beginStartDate?: string;
	endStartDate?: string;
};

export type AccessCodeResult = {
	success: boolean;
	message: string;
	data: AccessCodeData;
	productData?: AccessCodeData[];
};

const triggerAccessCode = async (_code: string): Promise<AccessCodeResult> => {
	return {
		success: false,
		message: "Access codes are unavailable",
		data: {
			bundleId: "",
			bundleNumericId: 0,
			bundleName: "",
			planLength: "",
			expiryDate: "",
			examName: "",
			examId: "",
			bundleType: "STUDY_PACK",
			icon: "",
			features: [],
			isCustomAccess: false,
		},
	};
};

export type { AccessCodeData };
export default triggerAccessCode;
